import { render, staticRenderFns } from "./AdminParameters.vue?vue&type=template&id=2a842959&scoped=true&"
import script from "./AdminParameters.vue?vue&type=script&lang=js&"
export * from "./AdminParameters.vue?vue&type=script&lang=js&"
import style0 from "./AdminParameters.vue?vue&type=style&index=0&id=2a842959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a842959",
  null
  
)

export default component.exports